export enum RiskForecastGraphs {
  Total,
  ByThreat
}
